
export class SliderConfig {
    showDots: boolean;
    showNavigator: boolean;
    showTitle: boolean;
    loop: boolean;
    showPreview: boolean;
    numberOfPreview: number;
    previewWidth: number;
    transitionDuration: number;
constructor() {
        this.showDots = true;
        this.showNavigator = true;
        this.showTitle = true;
        this.loop = true;
        this.showPreview = true;
        this.numberOfPreview = 2;
        this.previewWidth = 50;
        this.transitionDuration = 1;
    }
}

function SliderConfig_tsickle_Closure_declarations() {
/** @type {?} */
SliderConfig.prototype.showDots;
/** @type {?} */
SliderConfig.prototype.showNavigator;
/** @type {?} */
SliderConfig.prototype.showTitle;
/** @type {?} */
SliderConfig.prototype.loop;
/** @type {?} */
SliderConfig.prototype.showPreview;
/** @type {?} */
SliderConfig.prototype.numberOfPreview;
/** @type {?} */
SliderConfig.prototype.previewWidth;
/** @type {?} */
SliderConfig.prototype.transitionDuration;
}

